import initTree from '../../../../../../../ee/app/assets/javascripts/repository/index.js?vue3';
import { addShortcutsExtension } from '../../../../behaviors/shortcuts/index.js?vue3';
import ShortcutsNavigation from '~/behaviors/shortcuts/shortcuts_navigation';
import initAmbiguousRefModal from '../../../../vue_shared/components/ref/init_ambiguous_ref_modal.js?vue3';

initTree();
initAmbiguousRefModal();
addShortcutsExtension(ShortcutsNavigation);
